import { Table, TableHeader, TableRow, TableHeaderCell, TableCell, TableColumnSizingOptions, useTableFeatures, useTableColumnSizing_unstable, createTableColumn, TableColumnDefinition, MenuItem } from "@fluentui/react-components";
import React from "react";
import { TableBodyWithLoading } from "s365-dashboard-v2-file-picker";
import ShowLocalTime from "../../components/show-local-time/show-local-time.component";
import { ShareByMeFilterResponseModel, ShareDefinitionSourceType } from "../../swagger-clients/s365-dashboard-v2-api-clients.service";
import { useLoading } from "../../utils/loading-indicator.component";
import { processServerError } from "../../utils/helpers/error.helper";
import { getSharingClient } from "../../services/dispatcher.service";
import { getDashboardSharingClient } from "../../services/dashboard.service";
import { FileDisplayName } from "../../components/file-display-name/file-display-name.component";
import { ShareFileModal } from "../../files/share/share-file-modal.component";
import { ContextMenu, ContextMenuType } from "../../files/context-menu/context-menu.component";
import { PeopleAddRegular } from "@fluentui/react-icons";

type SharedByMeFiltersTableProps = {

}

export const SharedByMeFiltersTable: React.FC<SharedByMeFiltersTableProps> = (props) => {

    const [isLoading, loadingService] = useLoading();
    const [selectedItem, setSelectedItem] = React.useState<ShareByMeFilterResponseModel>();
    const [showShareModal, setShowShareModal] = React.useState<boolean>(false);
    const [items, setItems] = React.useState<ShareByMeFilterResponseModel[]>([]);
    const contextMenuRef = React.createRef<ContextMenuType>();

    React.useEffect(() => {
        getSharedFilters();
    }, []);


    const [columnSizingOptions] = React.useState<TableColumnSizingOptions>({       
        name: {
            minWidth: 100,
            defaultWidth: 400,
        },
        flowsheet: {
            minWidth: 300,
            defaultWidth: 400
        },
        created: {
            minWidth: 100,
            defaultWidth: 200

        }
    });

    const getContextItems = () => {
        if (!selectedItem) {
            return [];
        }
        let menuItems: JSX.Element[] = [];
        menuItems.push(<MenuItem key="share" icon={<PeopleAddRegular />} onClick={() => { setShowShareModal(true) }}> Share</MenuItem>);

        return menuItems;
    }


    const getSharedFilters = async () => {
        loadingService.showLoading("Loading filters...", async (hideMessage) => {

            try {
                const client = getDashboardSharingClient();
                const filtersResp = await client.getSharedByMeFilters();
                setItems(filtersResp ?? []);

            } catch (error) {
                processServerError(error, undefined, "An error occurred while getting filters that are shared by me.");

            } finally {
                hideMessage();
            }

        });

    }

    const isColumnCentered = (columnId: string) => {

        switch (columnId) {
            case "shared": return true;

            default: return false;
        }
    }

    const { getRows, columnSizing_unstable, tableRef } = useTableFeatures<ShareByMeFilterResponseModel>(
        {
            columns,
            items,
        },
        [useTableColumnSizing_unstable({ columnSizingOptions })]
    );


    return <div>
        <Table ref={tableRef} as="table" {...columnSizing_unstable.getTableProps()} >
            <TableHeader>
                <TableRow>
                    {columns.map((column) => (
                        <TableHeaderCell
                            onDragStart={e => {
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                            className={`${isColumnCentered(column.columnId as string) ? 'files-table__cell--center' : ''} files-table__cell--bold`}
                            {...columnSizing_unstable.getTableHeaderCellProps(
                                column.columnId
                            )}
                        >
                            {column.renderHeaderCell()}
                        </TableHeaderCell>
                    ))}
                </TableRow>
            </TableHeader>
            <TableBodyWithLoading isLoading={isLoading}
                columnCount={3} loadingMessage="Loading..."
                itemCount={items ? items.length : 0}
                noItemsMessage="No items found.">
                {items && items.length > 0 && items.map((item) => {
                    return <TableRow
                        key={`scenario-${item.id}`}
                        style={{ cursor: "pointer" }}
                        onClick={() => { setSelectedItem(item); }}
                        className={selectedItem && selectedItem.id == item.id ? "table-row-selected" : undefined}
                        onContextMenu={(ev) => { ev.preventDefault(); setSelectedItem(item); contextMenuRef.current?.showMenu(ev); }}
                    >
                        {columns.map((column) => (
                            <TableCell
                                className={`${isColumnCentered(column.columnId as string) ? ' column--center' : ''}`}
                                {...columnSizing_unstable.getTableCellProps(column.columnId)}
                            >
                                {column.renderCell(item)}
                            </TableCell>
                        ))}

                    </TableRow>
                })}


            </TableBodyWithLoading>
        </Table>
        <ContextMenu ref={contextMenuRef} hasIcons>
            {getContextItems()}
        </ContextMenu>

        {selectedItem && showShareModal &&
            <ShareFileModal
                sourceType={ShareDefinitionSourceType.Filter}
                sourceName={selectedItem.name}
                sourceUniqueId={selectedItem.id.toString()}
                isOpened={showShareModal}
                onClose={() => { setShowShareModal(false); }}
            />}


    </div>
}
const columns: TableColumnDefinition<ShareByMeFilterResponseModel>[] = [    
    createTableColumn<ShareByMeFilterResponseModel>({
        columnId: "name",
        renderHeaderCell: () => <>Name</>,
        renderCell: (item: ShareByMeFilterResponseModel) => {
            return <span>{item.name}</span>;

        }
    }),
    createTableColumn<ShareByMeFilterResponseModel>({
        columnId: "flowsheet",
        renderHeaderCell: () => <>Flowsheet</>,
        renderCell: (item: ShareByMeFilterResponseModel) => {
            return <FileDisplayName fileUniqueIdentifier={item.fileUniqueIdentifier} fileVersionNumber={item.fileVersionNumber} />;

        }
    }),
    createTableColumn<ShareByMeFilterResponseModel>({
        columnId: "shared",
        renderHeaderCell: () => <>Shared</>,
        renderCell: (item: ShareByMeFilterResponseModel) => {

            return <ShowLocalTime date={item.sharedAtUtc} multiline />;
        }
    })
];